<div class="bg-purple">

  <div class="stars">
    <div class="custom-navbar">
      <div class="brand-logo">
        <img src="/assets/images/favicon_mmonline.png" width="40px">
      </div>
      <div class="navbar-links">
        <ul>
          <!--          <li><a href="http://salehriaz.com/404Page/404.html" target="_blank">Home</a></li>-->
          <!--          <li><a href="http://salehriaz.com/404Page/404.html" target="_blank">About</a></li>-->
          <!--          <li><a href="http://salehriaz.com/404Page/404.html" target="_blank">Features</a></li>-->
          <li><a (click)="goToDashboard()" class="btn-go-home">{{strings['dashboard']}}</a></li>
        </ul>
      </div>
    </div>
    <div class="central-body">
      @switch (type) {
        @case (types.PROJECT_NOT_FOUND) {
          <h1 class="error-code">404</h1>
        }
        @case (types.SESSION_EXPIRED) {
          <h1 class="error-code">401</h1>
        }
        @default {
          <img class="image-404" src="/assets/images/404/404.svg" width="300px">
        }
      }

      <a (click)="goToDashboard()" class="btn-go-home">{{strings['go_back_home']}}</a>
      @switch (type) {
        @case (types.DEFAULT) {
          <div></div>
        }
        @case (types.PROJECT_NOT_FOUND) {
          <h1 style="font-family: awesome-sans, 'arial', sans-serif; color: white">{{strings['project_not_found']}}</h1>
        }
        @case (types.SESSION_EXPIRED) {
          <h1 style="font-family: awesome-sans, 'arial', sans-serif; color: white">{{strings['session_expired']}}</h1>
        }
      }

    </div>
    <div class="objects">
      <img class="object_rocket" src="/assets/images/404/rocket.svg" width="40px">
      <div class="earth-moon">
        <img class="object_earth" src="/assets/images/404/earth.svg" width="100px">
        <img class="object_moon" src="/assets/images/404/moon.svg" width="80px">
      </div>
      <div class="box_astronaut">
        <img class="object_astronaut" src="/assets/images/404/astronaut.svg" width="140px">
      </div>
    </div>
    <div class="glowing_stars">
      <div class="star"></div>
      <div class="star"></div>
      <div class="star"></div>
      <div class="star"></div>
      <div class="star"></div>

    </div>
  </div>
</div>
